/*eslint-disable*/ 
import React from "react";
import classNames from "classnames";
import styles from "pages-sections/services/ServicesSections.module.scss";


// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText1 from "pages-sections/services/SectionText1.js";
import SectionCards1 from "pages-sections/services/SectionCards1.js";
import SectionText2 from "pages-sections/services/SectionText2.js";
import SectionText3 from "pages-sections/services/SectionText3.js";
import SectionCards2 from "pages-sections/services/SectionCards2.js";
import SectionCards3 from "pages-sections/services/SectionCards3.js";

import Section4ClientsLandingPage from "pages-sections/home-page/Section4ClientsLandingPage.js";
import Section7Testimonials from "pages-sections/home-page/Section7Testimonials.js";







export default function BlogPostPage() {

  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Data, Analytics & Digital Marketing Services in Melbourne - Tribalism"
        image="/img/services/images/concrete.webp"
        url="https://www.tribalism.com.au/services"
        type="article"
        description="We are a Data & Analytics Agency based in Melbourne, Australia. We cover analytics, search engine marketing and web design. We help your digital platforms perfrorm better!"
       
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      {/* <Parallax image="/img/services/images/concrete.webp" filter="dark" small> */}
      <Parallax image="/img/services/images/concrete.webp" filter="dark" small>
        <div className={classNames(classes.container, classes.parallaxContent)}>
          <GridContainer justifyContent="center">

            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.titleWhite}>
                Our Services
              </h1>
              <h4 className={classes.subtitleWhite}>
                
                <br />We help your digital platforms perform better
              </h4>
              <br />

            </GridItem>

          </GridContainer>
        </div>
      </Parallax>

           <SectionText2 />
           <SectionCards2 />
           <SectionText1 />
           <SectionCards1 />
           <SectionText3 />
           <SectionCards3 />
           <div style={{backgroundColor: "rgb(255,255,255)"}}>
           <Section4ClientsLandingPage />
           </div>
           <Section7Testimonials />
        

      <Footer
        
      />
    </div>
  );
}
